export default "__VITE_ASSET__B$cWp8BE__"